import "./HomePage.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedProductHero from "./sections/FeaturedProductHero";
import FeaturedProducts from "./sections/FeaturedProducts";
import ProductCategoryGrid from "./sections/ProductCategoryGrid";
import HeroPromotion from "./sections/HeroPromotion";
import ProductListingGrid from "./sections/ProductListingGrid";
import Footer from "@/reusable_sections/Footer";
export default function HomePagePage() {
  return <div>
      <Header />
      <FeaturedProductHero />
      <FeaturedProducts />
      <ProductCategoryGrid />
      <HeroPromotion />
      <ProductListingGrid />
      <Footer />
    </div>;
}